// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  firebaseConfig: {
    apiKey: 'AIzaSyCDzLl6KA8l64hLLIZZ8gSNXsHsWb1RVvo',
    authDomain: 'hangcok-talk.firebaseapp.com',
    projectId: 'hangcok-talk',
    storageBucket: 'hangcok-talk.appspot.com',
    messagingSenderId: '104218286511',
    appId: '1:104218286511:web:dd095553abfaef382b775a',
    measurementId: 'G-KBH4R4E62N',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
